import { returnData, apiClientVersioned } from '../index'

import type { IPaginatedResponse } from '../index'
import type { ISelectedUser } from '../types/user'

export interface IUserBulkSearchResponse {
  results: Record<string, ISelectedUser[]>
}

export const UserApi = {
  search: (
    filters: { q: string; skip?: number; limit?: number },
    options?: { signal?: AbortSignal },
  ) =>
    returnData(
      apiClientVersioned.get<IPaginatedResponse<ISelectedUser>>(
        `/users/search`,
        {
          params: filters,
          signal: options?.signal,
        },
      ),
    ),
  bulkSearch: (
    payload: { queries: string[] },
    options?: { signal?: AbortSignal },
  ) =>
    returnData(
      apiClientVersioned.post<IUserBulkSearchResponse>(
        `/users/search/bulk`,
        payload,
        {
          signal: options?.signal,
        },
      ),
    ),
}
